import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const usePromocodeList = (params?: any) => {
  return useQuery({
    queryKey: ['promocode-list', params],
    queryFn: async () => {
      const res = await request.get('/promocode', { params });
      return res.data;
    }
  });
};
